import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { LastActivatedRoute } from "@modules/+new/shared/universal-modal/functions/last-activated-route.service";
import { Router } from "@angular/router";
import { TransactionsFacade } from "@modules/+new/transactions/domain/+state/transactions.facade";
import { PendingData } from "@modules/+new/shared/universal-modal/components/_presets/pending-preset/entities/pending-data";
import { interval, of, Subject, takeUntil } from "rxjs";
import { FiatTransactionDepositResponse } from "@modules/shared/domain/entities/fiat-transaction-deposit-response.model";
import { delay, switchMap, take, takeWhile } from "rxjs/operators";
import { ModalPreset } from "@modules/+new/shared/universal-modal/entities/modal-preset.interface";
import { HelpersService } from "@modules/+new/shared/universal-modal/components/_presets/helpers/helpers";

@Component({
	selector: "taking-longer-pending-preset",
	templateUrl: "./taking-longer-pending-preset.component.html",
	styleUrls: ["./taking-longer-pending-preset.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [HelpersService],
	standalone: false
})
export class TakingLongerPendingPresetComponent implements OnInit, ModalPreset<PendingData> {
	public data: PendingData = {};

	constructor(
		private readonly route: LastActivatedRoute,
		private readonly router: Router,
		private readonly transactionFacade: TransactionsFacade,
		@Inject(UniversalModalService) private readonly universalModal,
		private readonly helperService: HelpersService
	) {}

	ngOnInit(): void {
		const { pid, fpid } = this.route.getAllParams();
		this.data.transactionId = fpid;
		this.data.fiatWalletId = pid;
		this.fetchData();
	}

	public close(): void {
		this.universalModal.close(ModalCloseReason.close);
	}

	private fetchData(): void {
		const stopPolling$ = new Subject();
		let currentStatus: FiatTransactionDepositResponse = null;
		//retrying every 5 seconds for 15 seconds
		interval(5000)
			.pipe(
				switchMap(() => this.transactionFacade.getDepositTransactionResponse$(this.data.transactionId)),
				takeWhile((res) => {
					currentStatus = res;
					//we continue if the status is still pending
					return res.payment_status === "pending";
				}),
				delay(10000),
				switchMap(() => {
					// after 15 sec we end the loop
					stopPolling$.next(true);
					return of({});
				}),
				takeUntil(stopPolling$),
				take(1)
			)
			.subscribe({
				complete: () => {
					const baseUrl = `fiat-wallet/${this.data.fiatWalletId}/transaction/${this.data.transactionId}`;
					this.helperService.redirect(currentStatus, baseUrl);
				}
			});
	}
}
